/** Copy y reglas del confirm de lifecycle (desactivar / duplicar / activar). */

export type CatalogProductConfirmKind = 'deactivate' | 'duplicate' | 'reactivate';

export const CATALOG_DEACTIVATE_STOCK_BLOCK_MESSAGE =
  'Todavía hay stock en esta sucursal. Bajalo a cero y después lo desactivás.';

export const CATALOG_DEACTIVATE_STOCK_UNVERIFIED_MESSAGE =
  'No pudimos verificar el stock en esta sucursal. Reintentá para confirmar que no quede mercadería.';

export const CATALOG_DEACTIVATE_STOCK_CHECKING_MESSAGE = 'Verificando el stock…';

/**
 * Resultado de leer el stock de un producto en la sucursal activa.
 * `unverified` cubre lecturas fallidas o ausentes: nunca equivale a "sin stock".
 */
export type CatalogStockCheckResult =
  | { state: 'verified'; quantity: number }
  | { state: 'checking' }
  | { state: 'unverified' };

export type CatalogDeactivateBlock = 'none' | 'stock' | 'unverified' | 'checking';

/**
 * Decide si desactivar está bloqueado según el estado de la lectura de stock.
 * Servicios: nunca bloquea. Físicos: bloquea con stock verificado > 0 y exige
 * verificar (o reintentar) cuando la lectura no terminó o falló.
 */
export function catalogDeactivateBlock(
  itemType: string | null | undefined,
  check: CatalogStockCheckResult,
): CatalogDeactivateBlock {
  if (itemType === 'service') return 'none';
  if (check.state === 'checking') return 'checking';
  if (check.state === 'unverified') return 'unverified';
  return check.quantity > 0 ? 'stock' : 'none';
}
